import { zeroModalStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';

export const customModalStyles: ElementStyles = css`
  ${zeroModalStyles}
  :host(.company-entity-modal) .top slot {
    display: none;
  }
`;
